export const getTPASettings = (state) => state.tpaSettings;
export const getTPASettingsData = (state) => getTPASettings(state)?.settings ?? {};
export const getTPASettingsTranslations = (state, language) => getTPASettings(state).translations?.[language] ?? null;
export const getAllPostsLabelTranslation = ({ state, language, }) => {
    if (!language) {
        return null;
    }
    const tpaSettings = getTPASettings(state);
    return tpaSettings?.settings?.allPostsFeedLabel;
};
const getTPACommentsSettings = (state) => getTPASettingsData(state)?.comments ?? {};
export const hasTPACommentsSettings = (state) => typeof getTPASettingsData(state).comments !== 'undefined';
export const getTPASettingsIsCommentsEnabled = (state) => getTPACommentsSettings(state).enabled ?? true;
export const getTPASettingsIsAnonymousComments = (state) => getTPACommentsSettings(state).anonymousEnabled ?? false;
export const getTPASettingsIsRatingsEnabled = (state) => getTPACommentsSettings(state).ratingsEnabled ?? false;
export const getTPASettingsIsMandatoryRatingsEnabled = (state) => getTPACommentsSettings(state).ratingsMandatory ?? false;
export const getTPASettingsBlocksPostPage = (state) => getTPASettingsData(state).blocksPostPage ?? false;
export const getTPASettignsLiveSiteEditingDeprecated = (state) => (getTPASettingsData(state).liveSiteEditingDeprecated || getTPASettingsBlocksPostPage(state)) ??
    false;
//# sourceMappingURL=tpa-settings-selectors.js.map